import classNames from 'classnames'
import { push } from 'connected-react-router'
import { FirebaseDocRefType } from 'firebase/index'
import React, { FC, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styles from 'styles/components/list.module.scss'
import text from 'styles/utility/text.module.scss'
import { getExpiration } from 'lib/pointCard'
import { PointCardOfferType as BasePointCardOfferType } from 'types/pointCard/pointCardOffer'
import { PointCardUserOfferType as BasePointCardUserOfferType } from 'types/pointCard/pointCardUserOffer'
import { fetchPointCardUserOffersByOfferRef } from 'repos/pointCard/pointCardUserOffer'

type PointCardOfferType = BasePointCardOfferType & { ref: FirebaseDocRefType }
type PointCardUserOfferType = BasePointCardUserOfferType & { ref: FirebaseDocRefType }

type Props = {
  pointCardOffer: PointCardOfferType
}

const PointCardOfferListItem: FC<Props> = (props) => {
  const { pointCardOffer } = props
  const dispatch = useDispatch()

  const [pointCardUserOffers, setPointCardUserOffers] = useState<PointCardUserOfferType[]>([])

  const handleEditOffer = (id: string) => {
    dispatch(push(`/point_card/offer/${id}`))
  }

  useEffect(() => {
    ;(async () => {
      const res = await fetchPointCardUserOffersByOfferRef(pointCardOffer.ref)
      setPointCardUserOffers(res)
    })()
  }, [pointCardOffer])

  return (
    <li
      className={classNames(styles.pointCardOffer__item)}
      key={pointCardOffer.ref.id}
      onClick={() => handleEditOffer(pointCardOffer.ref.id)}
    >
      <h3 className={classNames(styles.pointCardOffer__name)}>{pointCardOffer.name}</h3>
      <p className={classNames(text.font_small)}>
        必要なポイント :
        <span className={classNames(text.color_blue)}>
          {pointCardOffer.condition.points}pt{pointCardOffer.condition.type === 'repeat' && 'ごとに繰り返し'}
        </span>
      </p>
      <p className={classNames(text.font_small)}>利用期限 : {getExpiration(pointCardOffer.expiration, 'offer')}</p>
      <p className={classNames(text.font_small)}>取得済み : {pointCardUserOffers.length.toLocaleString()}回</p>
      <img className={classNames(styles.pointCardOffer__icon)} src={'/icon/blue/arrow_next.svg'} alt={''} />
    </li>
  )
}

export default PointCardOfferListItem
